<template>
    <div class="filter" id="filter">
        <div class="modal-dialog modal-filter-dialog" :class="{ 'disable-control': loading }">
            <div class="modal-inner">
                <button type="button" class="btn-close btn-close-filter btn-close-modal">
                    <svg class="icon">
                        <use xlink:href="/img/front/icons/svgmap.svg#close" />
                    </svg>
                </button>
                <div class="filter-main-block" id="filter-main-block">
                    <div class="filter-title-row">  
                        <div class="filter-title">{{ trans('filter.filters') }}</div>
                        <button type="button" @click="cleanFilter" class="btn-filer-clear">
                            {{ trans('filter.clean_filters') }}
                        </button>
                    </div>
                    <div class="filter-body">
                        <div class="filter-row">    
                            <div class="filter-name">
                                {{ trans('filter.sort_by') }}
                            </div>
                            <div class="filter-amount"> 
                                
                                <label class="label-radio">
                                    <input value="default" type="radio" v-model="data.sort" name="sort">
                                    <span class="radio"></span>
                                    <span class="text">{{ trans('filter.default') }}</span>
                                </label>
                                <label class="label-radio">
                                    <input value="new" v-model="data.sort" type="radio" name="sort">
                                    <span class="radio"></span>
                                    <span class="text">{{ trans('filter.latest') }}</span>
                                </label>
                                <label class="label-radio">
                                    <input value="minToMax" type="radio" v-model="data.sort" name="sort">
                                    <span class="radio"></span>
                                    <span class="text">{{ trans('filter.from_min_to_max') }}</span>
                                </label>
                                <label class="label-radio">
                                    <input value="maxToMin" type="radio" v-model="data.sort" name="sort">
                                    <span class="radio"></span>
                                    <span class="text">{{ trans('filter.from_max_to_min') }}</span>
                                </label>
                                <label class="label-radio">
                                    <input value="MaxSaleToMinSale" v-model="data.sort" type="radio" name="sort">
                                    <span class="radio"></span>
                                    <span class="text">{{ trans('filter.from_max_to_min_sale') }}</span>
                                </label>
                            </div>
                        </div>
                        
                        <div class="filter-row filter-price-row">    
                            <div class="filter-name">
                                {{ trans('filter.price') }}
                            </div>
                            <div class="filter-price">
                                <label class="label-field label-field-char">
                                    <span class="field-name">{{ trans('filter.from') }}</span>
                                    <input type="number" :min="adapt_min_price" :max="adapt_max_price" ref="min" @input="changerPriceMin($event)"> <!-- TODO set ad get value witout model for set price without change data -->
                                    <span class="char">₴</span>
                                </label>
                                <span class="to-separator">
                                    -
                                </span>
                                <label class="label-field label-field-char">
                                    <span class="field-name">{{ trans('filter.to') }}</span>
                                    <input type="number" :min="adapt_min_price" :max="adapt_max_price" ref="max" @input="changerPriceMax($event)"> <!-- TODO set ad get value witout model for set price without change data -->
                                    <span class="char">₴</span>
                                </label>
                            </div>
                        </div>

                        <itemFilterButton
                            v-if="includer"
                            :name="trans('product.brand')"
                            system_name="brands"
                            :object="category.brands"
                            :checked_data="data.brands"
                            @open="openModal"
                            @clean="cleanFilter"
                        />

                        <itemFilterButton
                            v-if="includer"
                            :name="trans('general.country')"
                            system_name="countries"
                            :object="category.countries"
                            :checked_data="data.countries"
                            @open="openModal"
                            @clean="cleanFilter"
                        />

                        <div v-for="(attribute, index) in category.products_attributes" :key="index">
                            <itemFilterButton
                                v-if="includer"
                                :name="attribute.meta.title"
                                :system_name="attribute.slug"
                                :object="attribute.values"
                                :checked_data="data[attribute.slug]"
                                @open="openModal"
                                @clean="cleanFilter"
                            />
                        </div>

                    </div>
                </div>

                <itemFilterModal 
                    v-if="includer"
                    ref="brands"
                    system_name="brands"
                    :name="trans('general.brands')"
                    :all_name="trans('home.all_brands')"
                    :object="category.brands"
                    :props_checked_data="data.brands"
                    :includer="includer"
                    @change="updateIncluder"
                    @close="closeModal"
                />

                <itemFilterModal 
                    v-if="includer"
                    ref="countries"
                    system_name="countries"
                    :name="trans('general.countries')"
                    :all_name="trans('pages.all_countries')"
                    :object="category.countries"
                    :props_checked_data="data.countries"
                    :includer="includer"
                    @change="updateIncluder"
                    @close="closeModal"
                />

                <div v-for="(attribute, index) in category.products_attributes" :key="index">
                    <itemFilterModal 
                        v-if="includer"
                        :ref="attribute.slug"
                        :system_name="attribute.slug"
                        :name="attribute.meta.title"
                        :all_name="attribute.meta.title"
                        :object="attribute.values"
                        :props_checked_data="data[attribute.slug]"
                        :includer="includer"
                        @change="updateIncluder"
                        @close="closeModal"
                    />
                </div>

            </div>
            <div class="filter-bottom">
                <span class="filter-result">
                    <span v-if="includer.hasOwnProperty('count')">{{ trans('filter.found_products') }} {{ includer.count }}</span>
                </span>
                <button type="button" :disabled="loading" @click="confirm()" class="btn btn-close-filter btn-close-modal">
                    {{ trans('filter.show_products') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import itemFilterButton from "./itemFilterButton";
import itemFilterModal  from "./itemFilterModal";

export default {
    mixins: [],
    components: {
        itemFilterButton,
        itemFilterModal
    },
    props: {
        min_price: {
            requeired: false,
            default: 0
        },
        max_price: {
            requeired: false,
            default: 0
        },
        get_filter: {
            requeired: false,
            default: 0
        },
        category: {
            requeired: false,
            default: 0
        },
        object_type: {
            requeired: true
        },
        sales: {
            required: false,
            default: false
        }
    },
    watch: {
        data: {
            handler(val){
                this.getIncluderResults();
            },
            deep: true
        },
        choiced_objectName: null
    },
    computed: {
        adapt_max_price() {
            if (this.includer.hasOwnProperty('price_max')) {
                return this.includer.price_max;
            } else {
                return this.max_price;
            }
        },
        adapt_min_price() {
            if (this.includer.hasOwnProperty('price_min')) {
                return this.includer.price_min;
            } else {
                return this.min_price;
            }
        }
    },
    data() {
        return {
            clickedItem: null,
            data: this.get_filter,
            includer: {}
        }
    },
    beforeMount() {
        this.getIncluderResults();
    },
    mounted() {
        this.setFirstPrice();
        let filter_modal = document.getElementById('filter');
        filter_modal.addEventListener('click', function(e) {
            if (e.target == filter_modal) {
                filter_modal.classList.remove('modal-open');
                document.body.classList.remove('body-overflow');
            }
        });
    },
    methods: {
        cleanFilter(req) {
            if (req.hasOwnProperty('clean_name')) {
                this.data[req.clean_name] = [];
                if (this.$refs[req.clean_name][0]) {
                    this.$refs[req.clean_name]['checked_data'] = [];
                } else {
                    this.$refs[req.clean_name]['checked_data'] = [];
                }
            } else {
                for (const [key, value] of Object.entries(this.data)) {
                    if (key == 'priceMax') {
                        this.data[key] = this.max_price;
                    } else if (key == 'priceMin') {
                        this.data[key] = this.min_price;
                    } else if (key == 'sort') {
                        this.data[key] = 'default'
                    } else {
                        this.data[key] = [];
                        // And clean on checked_data all other refs
                        if (this.$refs[key]) {
                            if (this.$refs[key][0]) {
                                this.$refs[key][0].checked_data = [];
                            } else {
                                this.$refs[key].checked_data = [];
                            }
                        } 
                    }
                }
                this.setFirstPrice();
            }
        },
        setFirstPrice() {
            this.$refs.min.value = this.get_filter.priceMin;
            this.$refs.max.value = this.get_filter.priceMax;
        },
        changerPriceMin(event) {
            this.data.priceMin = event.target.value;
        },
        changerPriceMax(event) {
            this.data.priceMax = event.target.value;
        },
        openModal(val) {
            let element;
            if (this.$refs[val].length > 0) {
                element = this.$refs[val][0];
            } else {
                element = this.$refs[val];
            }
            element.$el.classList.remove('hidden-filter');
            document.querySelector('#filter-main-block').classList.add('filter-main-height');
        },
        closeModal(val) {
            let element;
            if (this.$refs[val].length > 0) {
                element = this.$refs[val][0];
            } else {
                element = this.$refs[val];
            }
            element.$el.classList.add('hidden-filter');
            document.querySelector('#filter-main-block').classList.remove('filter-main-height');
        },
        updateIncluder(val) {
            let objectName = val.name;
            let array = val.content;
            this.choiced_objectName = objectName;
            //console.log(this.choiced_objectName);
            this.data[objectName] = array;
        },
        confirm() {
            this.$emit("change", this.data);
            document.getElementById('filter').classList.remove('modal-open');
        },
        getIncluderResults() {
            clearTimeout(window.send);
            this.loading = true;
            // console.log(this.choiced_objectName);
            console.log(this.object_type);
            let category_id = this.category.id;
            if (!category_id) {
                category_id = null;
            }
            window.send = setTimeout(()=>{
              axios({
                  method: "post",
                  url: window.globalVariables.locale + "/get_filtered_includers_"+this.object_type,
                  data: {
                      category_id: category_id,
                      sales: this.sales,
                      filter: this.data,
                      choiced_objectName: this.choiced_objectName
                  }
              }).then(response => {
                  console.log('Result owned');
                  this.includer = response.data.includer;
                  this.loading = false;
              });
            }, 100);
        }
    }
}
</script>